import SystemNotificationsIcon from './containers/SystemNotificationsIconContainer'

export default SystemNotificationsIcon
